import { createContext, useContext } from 'react';

const Context = createContext(null);

export default Context;

export const useTokenViewContext = () => {
    return useContext(Context);
};
